var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor create-ticket" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.createTicketContactId"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: { placeholder: "Contact", "automation-mode": "" },
            model: {
              value: _vm.clone.contactId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "contactId", $$v)
              },
              expression: "clone.contactId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.createTicketSubject"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type Ticket Subject",
                "show-attributes": true,
                "show-emoji": true,
                "max-character-count": 1024,
              },
              model: {
                value: _vm.clone.subject,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "subject", $$v)
                },
                expression: "clone.subject",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.createTicketContactEmailAddress"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type contact email address or use attribute",
                "show-attributes": true,
                "show-emoji": false,
                "max-character-count": 400,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.email,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "email", $$v)
                },
                expression: "clone.email",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.createTicketContactPhoneNumber"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type contact phone number or use attribute",
                "show-attributes": true,
                "show-emoji": false,
                "max-character-count": 400,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.phone,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "phone", $$v)
                },
                expression: "clone.phone",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.createTicketTicketTag"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("a-auto-complete", {
              staticClass: "w-100",
              attrs: {
                "data-source": _vm.tagList,
                placeholder: "Select or Create a Ticket Tag",
              },
              on: {
                select: _vm.onSelect,
                search: _vm.onSearch,
                change: _vm.onChange,
              },
              model: {
                value: _vm.clone.tag,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "tag", $$v)
                },
                expression: "clone.tag",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.createTicketTicketMessage"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: { placeholder: "Ticket Message", "automation-mode": "" },
            model: {
              value: _vm.clone.message,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "message", $$v)
              },
              expression: "clone.message",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }